import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.inProduction = {
      alignItems: 'center',
      bg: 'background',
      color: 'text', // sets the color of all nav items and icons
      flexDirection: 'column',
      height: 'auto',
      position: 'sticky',
      width: '100%',
      top: 0,
      zIndex: 30,
    };

    // on customizer mode, we push the header under the customizer toolbar
    this.inCustomizer = {
      ...this.inProduction,
      top: 'var(--backpack-toolbar-height)',
    };
  })()
);
